import React from 'react';

export function SubmitIcon() {
  return (
    <svg
      className="me-1 -ms-1 w-5 h-5"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function AddIcon() {
  return (
    <svg
      className="w-6 h-6 text-gray-800 dark:text-white"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M5 12h14m-7 7V5"
      />
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg
      className="w-4 h-4 text-gray-800"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
      />
    </svg>
  );
}

export function StarIcon({ rating = 0, value = 0 }) {
  return (
    <svg
      className="w-6 h-6 text-gray-800 dark:text-white fill-current"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path
        stroke={rating > value ? `orange` : `gray`}
        strokeWidth="2"
        fill={rating > value ? `yellow` : `gray`}
        d="M11 5.1a1 1 0 0 1 2 0l1.7 4c.1.4.4.6.8.6l4.5.4a1 1 0 0 1 .5 1.7l-3.3 2.8a1 1 0 0 0-.3 1l1 4a1 1 0 0 1-1.5 1.2l-3.9-2.3a1 1 0 0 0-1 0l-4 2.3a1 1 0 0 1-1.4-1.1l1-4.1c.1-.4 0-.8-.3-1l-3.3-2.8a1 1 0 0 1 .5-1.7l4.5-.4c.4 0 .7-.2.8-.6l1.8-4Z"
      />
    </svg>
  );
}

export function InfoIcon() {
  return (
    <svg
      data-tooltip-id="my-tooltip"
      data-tooltip-content="Info"
      className="w-6 h-6"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <svg
        className="w-6 h-6 text-gray-800 dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="gray"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M10 11h2v5m-2 0h4m-2.6-8.5h0M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        />
      </svg>
    </svg>
  );
}

export function EyeIcon() {
  return (
    <svg
      className="w-6 h-6"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <svg
        className="w-6 h-6 text-gray-800 dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="green"
          strokeWidth="2"
          d="M21 12c0 1.2-4 6-9 6s-9-4.8-9-6c0-1.2 4-6 9-6s9 4.8 9 6Z"
        />
        <path stroke="green" strokeWidth="2" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
      </svg>
    </svg>
  );
}

export function EditIcon() {
  return (
    <svg
      className="w-6 h-6"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <svg
        className="w-6 h-6 text-gray-800 dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="orange"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="m14.3 4.8 2.9 2.9M7 7H4a1 1 0 0 0-1 1v10c0 .6.4 1 1 1h11c.6 0 1-.4 1-1v-4.5m2.4-10a2 2 0 0 1 0 3l-6.8 6.8L8 14l.7-3.6 6.9-6.8a2 2 0 0 1 2.8 0Z"
        />
      </svg>
    </svg>
  );
}

export function DeleteIcon() {
  return (
    <svg
      className="w-6 h-6"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <svg
        className="w-6 h-6 text-gray-800 dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="red"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
        />
      </svg>
    </svg>
  );
}

export function AutomatedMessageIcon() {
  return (
    <svg
      className="max-w-[24px] w-full"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2787_64392)">
        <path
          d="M12 0C5.37063 0 0 5.37063 0 12C0 18.6294 5.37063 24 12 24C18.6294 24 24 18.6294 24 12C24 5.37063 18.6294 0 12 0ZM13.6504 19.1049C13.6504 19.4685 13.3427 19.7762 12.979 19.7762H11.049C10.6853 19.7762 10.3776 19.4685 10.3776 19.1049V17.0909C10.3776 16.7273 10.6853 16.4196 11.049 16.4196H12.979C13.3427 16.4196 13.6504 16.7273 13.6504 17.0909V19.1049ZM13.6504 14.1538C13.6504 14.5175 13.3427 14.8252 12.979 14.8252H11.049C10.6853 14.8252 10.3776 14.5175 10.3776 14.1538V5.76224C10.3776 5.3986 10.6853 5.09091 11.049 5.09091H12.979C13.3427 5.09091 13.6504 5.3986 13.6504 5.76224V14.1538Z"
          fill="#3C310C"
        />
      </g>
      <defs>
        <clipPath id="clip0_2787_64392">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function BackIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 12 21" fill="none">
      <path
        d="M9.60938 20.3906C9.86719 20.6484 10.1953 20.7891 10.582 20.7891C11.3555 20.7891 11.9766 20.1797 11.9766 19.4062C11.9766 19.0195 11.8125 18.668 11.543 18.3984L3.33984 10.3828L11.543 2.39062C11.8125 2.12109 11.9766 1.75781 11.9766 1.38281C11.9766 0.609375 11.3555 0 10.582 0C10.1953 0 9.86719 0.140625 9.60938 0.398438L0.492188 9.30469C0.164062 9.60938 0.0117188 9.98438 0 10.3945C0 10.8047 0.164062 11.1562 0.492188 11.4727L9.60938 20.3906Z"
        fill="black"
      />
    </svg>
  );
}
export function DownloadIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.75 11.25V14.25C15.75 14.6478 15.592 15.0294 15.3107 15.3107C15.0294 15.592 14.6478 15.75 14.25 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V11.25"
        stroke="#321A50"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.25 7.49969L9 11.2497L12.75 7.49969"
        stroke="#321A50"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 11.25V2.25"
        stroke="#321A50"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EditBlackIcon() {
  return (
    <svg
      className="w-8 h-8"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <svg
        className="w-8 h-8 text-gray-800 dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="m14.3 4.8 2.9 2.9M7 7H4a1 1 0 0 0-1 1v10c0 .6.4 1 1 1h11c.6 0 1-.4 1-1v-4.5m2.4-10a2 2 0 0 1 0 3l-6.8 6.8L8 14l.7-3.6 6.9-6.8a2 2 0 0 1 2.8 0Z"
        />
      </svg>
    </svg>
  );
}

export function Ratingstar({ filled, onClick }) {
  return (
    <svg
      width="36"
      height="28"
      viewBox="0 0 36 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={{ cursor: 'pointer', fill: filled ? '#000' : '#FFF' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4653 25.2446C17.174 25.0915 16.826 25.0915 16.5347 25.2446L9.38891 29.0014C8.65528 29.3871 7.79785 28.7641 7.93796 27.9472L9.30268 19.9903C9.35831 19.6659 9.25077 19.3349 9.01508 19.1052L3.23404 13.4701C2.64053 12.8915 2.96804 11.8835 3.78826 11.7644L11.7775 10.6035C12.1032 10.5561 12.3847 10.3516 12.5304 10.0564L16.1033 2.81698C16.4701 2.07374 17.5299 2.07374 17.8967 2.81699L21.4696 10.0564C21.6153 10.3516 21.8968 10.5561 22.2226 10.6035L30.2117 11.7644C31.032 11.8835 31.3595 12.8915 30.766 13.4701L24.9849 19.1052C24.7492 19.3349 24.6417 19.6659 24.6973 19.9903L26.062 27.9472C26.2022 28.7641 25.3447 29.3871 24.6111 29.0014L17.4653 25.2446Z"
        stroke="#000"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CheckMarkIcon({ style }) {
  const greenTickUrl = 'https://images.myyogateacher.com/icons/ic-checkmark-48.png';
  return <img src={greenTickUrl} style={style} alt="icon" />;
}

export function CrossIcon({ style }) {
  const redTickUrl = 'https://images.myyogateacher.com/icons/ic-delete-48.png';
  return <img src={redTickUrl} style={style} alt="icon" />;
}
export function CopyClick() {
  return (
    <svg
      className="w-6 h-6 text-gray-800 dark:text-white"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        d="M18 3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1V9a4 4 0 0 0-4-4h-3a1.99 1.99 0 0 0-1 .267V5a2 2 0 0 1 2-2h7Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M8 7.054V11H4.2a2 2 0 0 1 .281-.432l2.46-2.87A2 2 0 0 1 8 7.054ZM10 7v4a2 2 0 0 1-2 2H4v6a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function WhatsappIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_8283_10620)">
        <path
          d="M8 0.40625C3.80625 0.40625 0.40625 3.80625 0.40625 8C0.40625 9.53438 0.8625 10.9656 1.64688 12.1594L0.66875 15.4719L4.10938 14.5188C5.24687 15.2 6.57812 15.5906 8 15.5906C12.1938 15.5906 15.5938 12.1906 15.5938 7.99687C15.5938 3.80625 12.1938 0.40625 8 0.40625Z"
          fill="#25D366"
        />
        <path
          d="M12.172 10.0844C12.1626 9.98443 12.1032 9.89693 12.0126 9.8563C11.4001 9.57505 10.7845 9.2938 10.172 9.01255C10.1032 8.9813 10.0189 8.99693 9.96886 9.0563L9.13761 9.9938C9.07198 10.0688 8.96886 10.0938 8.87824 10.0563C8.44699 9.87818 7.86573 9.57818 7.27823 9.07193C6.57511 8.4688 6.16261 7.82193 5.93136 7.40005C6.04698 7.32193 6.36261 7.08755 6.50324 6.65318C6.50324 6.65005 6.50636 6.64693 6.50636 6.64693C6.59386 6.37818 6.57511 6.08755 6.47824 5.82193C6.31261 5.3813 5.98136 4.52818 5.85324 4.39693C5.83136 4.37505 5.80636 4.35318 5.80636 4.35318C5.71261 4.2688 5.59073 4.22193 5.46261 4.21568C5.41886 4.21255 5.37198 4.21255 5.32199 4.21255C5.17824 4.20943 5.05011 4.20943 4.95636 4.22193C4.69074 4.25943 4.49698 4.43755 4.37511 4.58755C4.22823 4.76568 4.05323 5.0313 3.93761 5.3813C3.92823 5.41255 3.91886 5.44068 3.90948 5.47193C3.78136 5.91568 3.80636 6.39068 3.95948 6.82818C4.10323 7.23755 4.31261 7.72505 4.62824 8.24068C5.16261 9.1188 5.74386 9.66255 6.13761 10.0219C6.58136 10.4313 7.13136 10.9344 8.00324 11.3532C8.80949 11.7407 9.54074 11.8844 10.0314 11.9438C10.2314 11.9626 10.6001 11.9657 11.022 11.8063C11.2157 11.7313 11.3782 11.6407 11.5095 11.5438C11.8564 11.2969 12.1001 10.9251 12.1626 10.5063C12.1626 10.5032 12.1626 10.5001 12.1626 10.4969C12.1845 10.3376 12.1814 10.2001 12.172 10.0844Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_8283_10620">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SMSIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-message-square"
    >
      <path d="M21 15a2 2 0 0 1-2 2H7l-5 5V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      <line x1="8" y1="9" x2="16" y2="9" stroke="currentColor" strokeWidth="1" />
      <line x1="8" y1="12" x2="14" y2="12" stroke="currentColor" strokeWidth="1" />
      <line x1="8" y1="15" x2="12" y2="15" stroke="currentColor" strokeWidth="1" />
    </svg>
  );
}

export function RedirectIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5029 8.33335C17.9631 8.33335 18.3362 7.96025 18.3362 7.50002V2.50002C18.3362 2.03979 17.9631 1.66669 17.5029 1.66669H12.4999C12.0396 1.66669 11.6665 2.03978 11.6665 2.50002C11.6665 2.96025 12.0396 3.33335 12.4999 3.33335H15.4912L8.31898 10.5055C7.99355 10.8309 7.99355 11.3586 8.31898 11.684C8.64446 12.0095 9.17204 12.0095 9.49746 11.684L16.6695 4.512V7.50002C16.6695 7.96025 17.0426 8.33335 17.5029 8.33335ZM4.16663 4.16669C2.78592 4.16669 1.66663 5.28598 1.66663 6.66669V15.8334C1.66663 17.2141 2.78592 18.3334 4.16663 18.3334H13.3333C14.714 18.3334 15.8333 17.2141 15.8333 15.8334V10.8334C15.8333 10.3731 15.4602 10 15 10C14.5397 10 14.1666 10.3731 14.1666 10.8334V15.8334C14.1666 16.2936 13.7935 16.6667 13.3333 16.6667H4.16663C3.70639 16.6667 3.33329 16.2936 3.33329 15.8334V6.66669C3.33329 6.20645 3.70639 5.83335 4.16663 5.83335H9.16663C9.62688 5.83335 9.99996 5.46025 9.99996 5.00002C9.99996 4.53979 9.62688 4.16669 9.16663 4.16669H4.16663Z"
        fill="black"
      />
    </svg>
  );
}

export function DOCIcon() {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="29" height="29" rx="5.5" fill="white" />
      <rect x="0.5" y="0.5" width="29" height="29" rx="5.5" stroke="#F2F2F2" />
      <g clipPath="url(#clip0_33_6578)">
        <path
          d="M10.3125 23H19.6875C20.4629 23 21.0938 22.3692 21.0938 21.5938V11.6875H17.8125C17.0371 11.6875 16.4062 11.0567 16.4062 10.2812V7H10.3125C9.53706 7 8.90625 7.63081 8.90625 8.40625V21.5938C8.90625 22.3692 9.53706 23 10.3125 23ZM12.1875 13.5938H17.8125C18.0716 13.5938 18.2812 13.8034 18.2812 14.0625C18.2812 14.3216 18.0716 14.5312 17.8125 14.5312H12.1875C11.9284 14.5312 11.7188 14.3216 11.7188 14.0625C11.7188 13.8034 11.9284 13.5938 12.1875 13.5938ZM12.1875 15.4688H17.8125C18.0716 15.4688 18.2812 15.6784 18.2812 15.9375C18.2812 16.1966 18.0716 16.4062 17.8125 16.4062H12.1875C11.9284 16.4062 11.7188 16.1966 11.7188 15.9375C11.7188 15.6784 11.9284 15.4688 12.1875 15.4688ZM12.1875 17.3438H17.8125C18.0716 17.3438 18.2812 17.5534 18.2812 17.8125C18.2812 18.0716 18.0716 18.2812 17.8125 18.2812H12.1875C11.9284 18.2812 11.7188 18.0716 11.7188 17.8125C11.7188 17.5534 11.9284 17.3438 12.1875 17.3438ZM12.1875 19.2188H15.9375C16.1966 19.2188 16.4062 19.4284 16.4062 19.6875C16.4062 19.9466 16.1966 20.1562 15.9375 20.1562H12.1875C11.9284 20.1562 11.7188 19.9466 11.7188 19.6875C11.7188 19.4284 11.9284 19.2188 12.1875 19.2188Z"
          fill="#EE721C"
        />
        <path
          d="M17.8125 10.7498H20.8191L17.3438 7.27441V10.281C17.3438 10.5396 17.5539 10.7498 17.8125 10.7498Z"
          fill="#EE721C"
        />
      </g>
      <defs>
        <clipPath id="clip0_33_6578">
          <rect width="16" height="16" fill="white" transform="translate(7 7)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ModalCloseIcon() {
  return (
    <svg width="22" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.5 5.5L5.5 16.5"
        stroke="#BFBFBF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 5.5L16.5 16.5"
        stroke="#BFBFBF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PlayIcon() {
  return (
    <svg width="66" height="65" viewBox="0 0 66 65" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5.73218" y="5.19141" width="54.3403" height="54.3403" rx="27.1702" fill="#F86624" />
      <rect
        x="3.1505"
        y="2.60972"
        width="59.5037"
        height="59.5037"
        rx="29.7518"
        stroke="#F86624"
        strokeOpacity="0.15"
        strokeWidth="5.16336"
      />
      <path
        d="M44.0898 32.3629C44.0889 32.6581 44.0063 32.9472 43.8512 33.1983C43.696 33.4494 43.4744 33.6526 43.2108 33.7854L27.2283 41.7766C27.0057 41.8907 26.7593 41.9509 26.5091 41.9524C26.2099 41.9534 25.9164 41.8703 25.6621 41.7127C25.4317 41.5687 25.2419 41.3684 25.1105 41.1307C24.979 40.8931 24.9103 40.6258 24.9109 40.3542V24.3717C24.9117 24.0993 24.9822 23.8316 25.1156 23.594C25.249 23.3565 25.4409 23.157 25.6731 23.0144C25.9053 22.8719 26.17 22.7911 26.4422 22.7797C26.7144 22.7683 26.985 22.8267 27.2283 22.9493L43.2108 30.9405C43.4744 31.0733 43.696 31.2765 43.8512 31.5276C44.0063 31.7787 44.0889 32.0678 44.0898 32.3629Z"
        fill="white"
      />
    </svg>
  );
}

export function PauseIcon() {
  return (
    <svg width="36" height="35" viewBox="0 0 36 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="6" y="5.81348" width="24" height="24" rx="12" fill="white" />
      <rect
        x="3.41832"
        y="3.23179"
        width="29.1634"
        height="29.1634"
        rx="14.5817"
        stroke="#F86624"
        strokeOpacity="0.15"
        strokeWidth="5.16336"
      />
      <path
        d="M18 5.81348C11.3732 5.81348 6 11.1867 6 17.8135C6 24.4403 11.3732 29.8135 18 29.8135C24.6268 29.8135 30 24.4403 30 17.8135C30 11.1867 24.6268 5.81348 18 5.81348ZM15.8571 21.8849C15.8571 22.0028 15.7607 22.0992 15.6429 22.0992H14.3571C14.2393 22.0992 14.1429 22.0028 14.1429 21.8849V13.742C14.1429 13.6242 14.2393 13.5278 14.3571 13.5278H15.6429C15.7607 13.5278 15.8571 13.6242 15.8571 13.742V21.8849ZM21.8571 21.8849C21.8571 22.0028 21.7607 22.0992 21.6429 22.0992H20.3571C20.2393 22.0992 20.1429 22.0028 20.1429 21.8849V13.742C20.1429 13.6242 20.2393 13.5278 20.3571 13.5278H21.6429C21.7607 13.5278 21.8571 13.6242 21.8571 13.742V21.8849Z"
        fill="#EE731B"
      />
    </svg>
  );
}

export function BlackCloseIcon() {
  return (
    <svg
      className="zm:h-27px w-27px md:h-52px md:w-52px"
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_362_32874)">
        <rect opacity="0.95" x="4" width="44" height="44" rx="22" fill="black" fillOpacity="0.8" />
        <path
          d="M31.5 16.5L20.5 27.5"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.5 16.5L31.5 27.5"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_362_32874"
          x="0.333333"
          y="0"
          width="51.3333"
          height="51.3333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.66667" />
          <feGaussianBlur stdDeviation="1.83333" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_362_32874" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_362_32874"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function VideoIcon() {
  return (
    <svg width="20" height="20" fill="currentColor">
      <path d="M4 4h12v12H4z" fill="#000" />
      <polygon points="8,6 14,10 8,14" fill="#fff" />
    </svg>
  );
}
export function PdfLogoIcon() {
  return (
    <svg
      width="31"
      height="19"
      viewBox="0 0 31 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="MyYogaTeacher"
    >
      <g clipPath="url(#clip0_4846_3515)">
        <path
          d="M22.3528 14.9479V12.7045C22.0497 12.7453 21.7831 12.8055 21.5541 12.8819C21.0811 13.0388 20.7651 13.2484 20.5297 13.5161C20.3738 13.6956 20.2481 13.9074 20.1524 14.1761C20.0234 14.5319 19.9492 14.9909 19.9492 15.5585V18.678H22.2786H22.3528H24.4124V18.1007C24.4124 18.1007 22.3625 17.8546 22.3528 14.9479Z"
          fill="#EE731B"
        />
        <path
          d="M14.3538 11.5339C14.3538 7.93064 11.7019 4.94766 8.24271 4.42846C8.24056 4.43276 8.23841 4.43706 8.23626 4.44136C7.87507 4.38332 7.50422 4.35107 7.12798 4.34892C3.34094 4.37042 0.248313 7.32115 0 11.0501H5.89717V11.0523C5.90792 11.0523 5.91759 11.0512 5.92727 11.0512C7.41177 11.0512 8.61679 12.2433 8.64044 13.7225H8.64366V14.9479C8.63399 17.8546 6.58298 18.1007 6.58298 18.1007V18.678H8.64366H8.71676H14.3559V11.7693H14.3506C14.3527 11.6908 14.3538 11.6123 14.3538 11.5339Z"
          fill="#EE731B"
        />
        <path
          d="M21.2863 11.2781C21.9205 11.1018 22.6311 11.0244 23.4308 11.0244H30.7082C30.5868 9.28948 29.8494 7.72542 28.7153 6.54728C27.4114 5.21542 25.5947 4.38878 23.5846 4.38878C22.0151 4.38878 20.565 4.89294 19.3826 5.74644C19.3579 5.76794 19.331 5.78729 19.303 5.80557C19.2934 5.81309 19.2837 5.81954 19.2729 5.82707L19.2708 5.82492C19.1525 5.89371 19.015 5.93349 18.8677 5.93349C18.4216 5.93349 18.0615 5.5723 18.0615 5.1262C18.0615 4.87896 18.1733 4.65752 18.3485 4.51025V4.50918C18.3506 4.50703 18.3528 4.50595 18.3549 4.5038C18.3786 4.48446 18.4033 4.46725 18.428 4.45006C19.3149 3.80724 20.3242 3.32566 21.4164 3.04725C19.9351 1.33808 17.7497 0.256681 15.3118 0.256681C12.9017 0.256681 10.7389 1.31228 9.2598 2.98705C13.1049 3.92763 15.9664 7.40294 15.9664 11.5329V11.5587H15.9686V18.677H18.3388V15.5575C18.3388 14.7663 18.4517 14.0493 18.7204 13.4141C18.987 12.7798 19.4267 12.2391 19.9975 11.8565C20.378 11.5995 20.8112 11.4103 21.2863 11.2781Z"
          fill="#EE731B"
        />
      </g>
      <defs>
        <clipPath id="clip0_4846_3515">
          <rect width="31" height="19" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CardIcon({ width = 26, height = 20, ...props }) {
  return (
    <svg
      width="26"
      height="20"
      viewBox="0 0 26 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="2" y="2" width="22" height="16" fill="#fff" />
      <path
        d="M22 2H4C2.89543 2 2 2.89543 2 4V16C2 17.1046 2.89543 18 4 18H22C23.1046 18 24 17.1046 24 16V4C24 2.89543 23.1046 2 22 2Z"
        stroke="#3c82f6"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 8H24"
        stroke="#3c82f6"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function RequestInfoIcon({ width = 22, height = 22, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
